export default "__VITE_ASSET__rLsRx89g__"